// 공통 Helper

// 계정의 accountTypeCode으로 User Type 리턴
export const getUserType = (accountTypeCode: string) => {
  if (!accountTypeCode) {
    return "";
  }

  return accountTypeCode.split(":").pop();
};

const contentClassName: any = {
  about: "",
  partner: "content-partner",
  mission: "",
  pricing: "",
  contact: "content-contact",
};

// common layout에 정의된 element의 classname을 path별로 가져오는 공통 로직
export const getLayoutClassNameByPath = (pathName: string) => {
  const pathNameList = pathName.split("/");

  const firstPath = pathNameList[1];

  // common home
  if (firstPath === "") {
    return "content-home";
  }

  // agency
  if (firstPath === "agency") {
    return "content-home content-agency content-message";
  }

  if (firstPath === "school") {
    return "content-home content-school content-message content-student-detail";
  }

  if (firstPath === "student") {
    return "content-home content-student content-message";
  }

  try {
    if (pathNameList.length === 2) {
      return contentClassName[firstPath];
    }
  } catch {
    return "";
  }

  return "";
};
// 기기의 네비게이션 바 높이 값을 가져오는 함수
export const getNavigationBarHeight = () => {
  try {
    // 방법 1: CSS env() 함수를 사용하여 safe-area-inset-bottom 값 가져오기
    const testElement = document.createElement('div');
    testElement.style.position = 'fixed';
    testElement.style.bottom = '0';
    testElement.style.left = '0';
    testElement.style.right = '0';
    testElement.style.height = 'env(safe-area-inset-bottom)';
    testElement.style.visibility = 'hidden';
    testElement.style.pointerEvents = 'none';
    testElement.style.zIndex = '-9999';

    document.body.appendChild(testElement);
    const computedStyle = window.getComputedStyle(testElement);
    const height = computedStyle.height;
    document.body.removeChild(testElement);

    // px 값을 숫자로 변환
    let numericHeight = parseFloat(height.replace('px', ''));

    // 방법 2: window.innerHeight와 document.documentElement.clientHeight 차이로 계산
    if (isNaN(numericHeight) || numericHeight === 0) {
      const viewportHeight = window.innerHeight;
      const documentHeight = document.documentElement.clientHeight;
      const heightDifference = viewportHeight - documentHeight;

      // 차이가 20px 이상이면 네비게이션 바가 있는 것으로 간주
      if (heightDifference > 20) {
        numericHeight = heightDifference;
      }
    }

    // 방법 3: iOS Safari의 경우 window.visualViewport 사용
    if ((isNaN(numericHeight) || numericHeight === 0) && window.visualViewport) {
      const visualHeight = window.visualViewport.height;
      const windowHeight = window.innerHeight;
      const heightDiff = windowHeight - visualHeight;

      if (heightDiff > 0) {
        numericHeight = heightDiff;
      }
    }

    console.log('네비게이션 바 높이 감지 결과:', {
      envMethod: height,
      numericHeight,
      viewportHeight: window.innerHeight,
      documentHeight: document.documentElement.clientHeight,
      visualViewportHeight: window.visualViewport?.height
    });

    return isNaN(numericHeight) ? 0 : Math.max(0, numericHeight);
  } catch (error) {
    console.warn('네비게이션 바 높이를 가져올 수 없습니다:', error);
    return 0;
  }
};

// 네비게이션 바 높이를 기반으로 패딩 계산
export const calculateMenuPadding = () => {
  const navBarHeight = getNavigationBarHeight();
  const basePadding = 24; // pb-4 = 1rem = 16px
  const totalPadding = basePadding + navBarHeight;

  // Tailwind CSS 클래스로 변환 (4px 단위)
  const paddingValue = Math.ceil(totalPadding / 4);
  return `pb-${paddingValue}`;
};
